import React, { useState, useRef, useEffect } from 'react';
import './Auth.css';

export default function OTP({ onLogin, onBack }) {
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const [timer, setTimer] = useState(60);
  const refs = useRef([]);

  useEffect(() => {
    const t = setInterval(() => setTimer(v => v > 0 ? v - 1 : 0), 1000);
    return () => clearInterval(t);
  }, []);

  const handleChange = (i, val) => {
    if (!/^\d?$/.test(val)) return;
    const next = [...otp];
    next[i] = val;
    setOtp(next);
    if (val && i < 5) refs.current[i + 1]?.focus();
    if (next.every(d => d !== '') ) setTimeout(onLogin, 300);
  };

  const handleKey = (i, e) => {
    if (e.key === 'Backspace' && !otp[i] && i > 0) refs.current[i - 1]?.focus();
  };

  return (
    <div className="auth-shell">
      <div className="auth-left">
        <div className="auth-card">
          <button className="auth-back" onClick={onBack}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="15 18 9 12 15 6"/></svg>
            Back to login
          </button>

          <div className="auth-logo" style={{ marginBottom: 16 }}>
            <svg width="40" height="40" viewBox="0 0 100 100" fill="none">
              <circle cx="50" cy="42" r="30" fill="#2d5a1b" stroke="#A7F432" strokeWidth="2"/>
              <path d="M35 42 Q42 30 50 42 Q58 54 65 42" stroke="#A7F432" strokeWidth="3" fill="none" strokeLinecap="round"/>
            </svg>
          </div>

          <h1 className="otp-title">Enter OTP</h1>
          <p className="otp-sub">We sent a 6-digit code to your email address</p>

          <div className="otp-inputs">
            {otp.map((d, i) => (
              <input
                key={i}
                ref={el => refs.current[i] = el}
                className={`otp-box ${d ? 'filled' : ''}`}
                maxLength={1}
                value={d}
                onChange={e => handleChange(i, e.target.value)}
                onKeyDown={e => handleKey(i, e)}
                inputMode="numeric"
              />
            ))}
          </div>

          <p className="otp-resend">
            {timer > 0
              ? <>Resend code in <span style={{ color: 'var(--accent)', fontWeight: 600 }}>{timer}s</span></>
              : <><button className="resend-link" onClick={() => setTimer(60)}>Resend code</button></>
            }
          </p>

          <button className="auth-btn" onClick={onLogin}>Verify</button>
        </div>
      </div>

      <div className="auth-right">
        <div className="auth-welcome">
          <h2>Almost <span>there</span></h2>
          <p>Verify your identity to access the admin</p>
        </div>
      </div>
    </div>
  );
}
